import React from 'react';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
    size?: number;
};

const Reflect01Icon = ({
    color = 'currentColor',
    size = 24,
    strokeWidth = 2,
    strokeLinecap = 'round',
    strokeLinejoin = 'round',
    ...props
}: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            stroke={color}
            strokeLinecap={strokeLinecap}
            strokeLinejoin={strokeLinejoin}
            strokeWidth={strokeWidth}
            d="M3 12h3m4.5 0h3m4.5 0h3M7.99 20.712l3.376-4.388c.216-.28.324-.42.455-.47a.5.5 0 0 1 .358 0c.131.05.24.19.455.47l3.375 4.388c.319.414.478.62.476.794a.5.5 0 0 1-.19.386c-.137.108-.398.108-.92.108h-6.75c-.522 0-.783 0-.92-.108a.5.5 0 0 1-.19-.386c-.002-.173.157-.38.476-.794m0-17.424 3.376 4.388c.216.28.324.42.455.47a.5.5 0 0 0 .358 0c.131-.05.24-.19.455-.47l3.375-4.388c.319-.414.478-.62.476-.794a.5.5 0 0 0-.19-.387C16.157 2 15.896 2 15.374 2h-6.75c-.522 0-.783 0-.92.107a.5.5 0 0 0-.19.387c-.002.173.157.38.476.794"
        />
    </svg>
);
export { Reflect01Icon };
